module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }